import { Dispatch } from "redux";
import {
  ANULAR_DOCUMENTO_VISADO_REQUEST,
  ANULAR_DOCUMENTO_VISADO_SUCCESS,
  ANULAR_DOCUMENTO_VISADO_FAIL,
} from "../types";
import axiosInstance from "../../../../services/axiosConfig";

export const AnularDocumentoVisadoActions = (documento: number) => async (dispatch: Dispatch): Promise<boolean> => {

  const body = JSON.stringify(documento);

  dispatch({ type: ANULAR_DOCUMENTO_VISADO_REQUEST });

  try {
    const res = await axiosInstance.post(`${import.meta.env.VITE_CSRF_API_URL}/AnularDocumentoVisado`, body);

    if (res.status === 200) {
      dispatch({
        type: ANULAR_DOCUMENTO_VISADO_SUCCESS,
        payload: res.data
      });
      return true;
    } else {
      dispatch({
        type: ANULAR_DOCUMENTO_VISADO_FAIL,
        error:
          "No se pudo rechazar la alta seleccionada. Por favor, intente nuevamente.",
      });
      return false;
    }
  } catch (err: any) {
    dispatch({
      type: ANULAR_DOCUMENTO_VISADO_FAIL,
      error: "Error en la solicitud:", err,
    });

    return false;
  }

};
